export default {
    setConnectedAccounts(state, payload) {
        state.connectedSikayetvarAccounts = payload;
    }
}